module.exports = __webpack_public_path__ + "img/logo-cotizacion.de5dfcc5.png";